import { render, staticRenderFns } from "./ReceiptLayout.vue?vue&type=template&id=3650aa3e&scoped=true&"
import script from "./ReceiptLayout.vue?vue&type=script&lang=js&"
export * from "./ReceiptLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3650aa3e",
  null
  
)

export default component.exports